<template>
  <div>
    <el-button size="mini" :disabled="disabled" @click="openGroupSavePopup">그룹 저장</el-button>
    <w-sliding-popup type="setting" ref="slidingPopup" title="그룹 저장" width="500px" @open="open" @close="close">
      <div slot="content">
        <el-form :model="formData" label-position="top" ref="form">
          <el-row v-if="managetypeId === 'NMS'">
            <el-form-item label="중요도" prop="objImportance" :rules="{validator: validator}">
              <div style="width:100%" class="vertical-center-box">
                <el-input type="number" v-model="formData.objImportance" :disabled="!checkedData.objImportance" placeholder="입력해 주세요."
                :min="1" :max="5" controls-position="right" @blur="objImportanceFocusOut" @keyup.enter.native="objImportanceFocusOut" />
                <el-checkbox class="mr-l4" v-model="checkedData.objImportance" />
              </div>
            </el-form-item>
          </el-row>
          <el-row v-if="managetypeId === 'NMS' && (customerId === customer.SKCC || customerId === customer.SKT)">
            <el-form-item label="고객사" prop="skccCustomerId" :rules="{validator: validator}">
              <div style="width:100%" class="vertical-center-box">
                <el-select v-model="formData.skccCustomerId" :disabled="!checkedData.skccCustomerId" style="width:100%">
                  <el-option v-for="item in skccCustomerList" :key="item.customerId" :label="item.customerName" :value="item.customerId"></el-option>
                </el-select>
                <el-checkbox class="mr-l4" v-model="checkedData.skccCustomerId"/>
              </div>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="수집/판단 정책" prop="rscEventRuleId" :rules="{validator: validator}">
              <div style="width:100%" class="vertical-center-box">
                <el-select v-model="formData.rscEventRuleId" :disabled="!checkedData.rscEventRuleId" style="width:100%">
                  <el-option v-for="item in rscEventRuleList" :key="item.ruleTmplId" :label="item.ruleTmplName" :value="item.ruleTmplId"></el-option>
                </el-select>
                <el-checkbox class="mr-l4" v-model="checkedData.rscEventRuleId"/>
              </div>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="이벤트/판단 정책" prop="eventAlarmRuleId" :rules="{validator: validator}">
              <div style="width:100%" class="vertical-center-box">
                <el-select v-model="formData.eventAlarmRuleId" :disabled="!checkedData.eventAlarmRuleId" style="width:100%">
                  <el-option v-for="item in eventAlarmRuleList" :key="item.ruleTmplId" :label="item.ruleTmplName" :value="item.ruleTmplId"></el-option>
                </el-select>
                <el-checkbox class="mr-l4" v-model="checkedData.eventAlarmRuleId"/>
              </div>
            </el-form-item>
          </el-row>
        </el-form>
      </div>
      <div slot="footer">
        <el-button size="large" type="solid" @click="clickSaveButton">저장</el-button>
        <el-button size="large" @click="clickCancelButton">취소</el-button>
      </div>
    </w-sliding-popup>
  </div>
</template>

<script>
import { isNil } from 'lodash';
import msgUtil from '@/utils/message';
import SkccCustomerAPI from '@/api/model/skcc-customer';
import { customer } from '@/constants/customer-define';

export default {
  name: 'WGroupSaveButton',
  props: {
    managetypeId: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: true,
    },
    rscEventRuleList: {
      type: Array,
      default: () => [],
    },
    eventAlarmRuleList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    customerId() {
      return this.$store.state.common.customerId;
    },
  },
  data() {
    return {
      customer,
      formData: {
        objImportance: null,
        skccCustomerId: null,
        rscEventRuleId: null,
        eventAlarmRuleId: null,
      },
      checkedData: {
        objImportance: false,
        skccCustomerId: false,
        rscEventRuleId: false,
        eventAlarmRuleId: false,
      },
      skccCustomerList: [],
    };
  },
  methods: {
    open() {
      if (this.managetypeId === 'NMS' && (this.customerId === this.customer.SKCC || this.customerId === this.customer.SKT)) {
        const target = '고객사';
        const action = msgUtil.action.VIEW;
        SkccCustomerAPI.getSkccCustomerList().then((response) => {
          if (response.data.success) {
            const data = response.data.data;
            this.skccCustomerList = data;
          } else {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          }
        }).catch(() => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
        });
      }
    },
    close() {
      this.$refs.form.resetFields();
      this.checkedData = {
        objImportance: false,
        skccCustomerId: false,
        rscEventRuleId: false,
        eventAlarmRuleId: false,
      };
    },
    closePopup() {
      this.$refs.slidingPopup.visible = false;
    },
    openGroupSavePopup() {
      this.$refs.slidingPopup.visible = true;
    },
    clickSaveButton() {
      this.$refs.form.validate().then((valid) => {
        if (valid) {
          const result = {};
          Object.entries(this.checkedData).forEach((item) => {
            if (item[1]) {
              result[item[0]] = this.formData[item[0]];
            }
          });
          this.$emit('group-save', result);
          this.closePopup();
        }
      }).catch(() => {});
    },
    clickCancelButton() {
      this.closePopup();
    },
    objImportanceFocusOut() {
      const objImportance = this.formData.objImportance;
      if (isNil(objImportance) || objImportance === '') {
        return;
      }
      if (objImportance < 1) {
        this.formData.objImportance = 1;
      } else if (objImportance > 5) {
        this.formData.objImportance = 5;
      }
    },
    validator(rule, value, callback) {
      if (!this.checkedData[rule.field]) {
        callback();
        return;
      }
      if (isNil(value) || value === '') {
        callback(new Error('입력해주세요.'));
      } else {
        callback();
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/components/GroupSaveButton.vue